import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { pageTitle } from "../../helpers/PageTitle";
import "../../sass/shortcode/Faqs.scss";

// Accordion Item Component
function FAQItem({ question, answer, isOpen, onClick }) {
  return (
    <div className="faq-item">
      <button onClick={onClick}>
        <span>{question}</span>
        <span className={isOpen ? "open" : ""}>{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && (
        <div className="faq-answer">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQs() {
  pageTitle("FAQs");

  // Track the index of the currently open FAQ
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "What services does Medayus offer?",
      answer:
        "Medayus provides online Ayurvedic consultation and family physician services. We offer personalized treatment plans, health guidance, and prescription support. Our goal is to make quality healthcare accessible from the comfort of your home."
    },
    {
      question: "How do I schedule an appointment with Medayus?",
      answer:
        "Booking is simple! Select your preferred date and time on our website, fill in your details, and confirm your slot. You’ll receive a confirmation message with all the information you need."
    },
    {
      question: "Is Ayurvedic consultation right for me?",
      answer:
        "Yes! Ayurveda is a holistic approach to health suitable for all age groups. It focuses on natural healing, lifestyle guidance, and long-term wellness rather than just symptom relief."
    },
    {
      question: "How do I request a prescription refill?",
      answer:
        "You can request a refill by contacting us through our website or patient profile. Our doctor will review your case and send you the updated prescription or next steps as needed."
    },
    {
      question: "Do you accept insurance?",
      answer:
        "We currently do not process insurance claims directly. However, we can provide a detailed bill that you may use to request reimbursement from your insurance provider"
    }
  ];

  return (
    <>
      {/* Header Banner */}
      <section className="cs_faq_banner">
        <span className="cs_faq_dots cs_faq_dots_1" />
        <span className="cs_faq_dots cs_faq_dots_2" />
        <span className="cs_faq_ring" />
        <div className="container">
          <div className="cs_faq_banner_row">
            <div className="cs_faq_banner_left">
              <div className="cs_faq_icon">
                <span className="cs_faq_icon_circle">?</span>
              </div>
              <h1>
                Frequently Asked
                <br />
                Questions <span>(FAQs)</span>
              </h1>
              <span className="cs_faq_underline" />
              <p>
                Find quick answers to the most common questions about our
                services, appointments, and more.
              </p>
            </div>
            <div className="cs_faq_banner_right">
              <div className="cs_faq_blob">
                <div className="cs_faq_bubble_dots">
                  <span />
                  <span />
                  <span />
                </div>
                <div className="cs_faq_bubble_main">FAQ</div>
                <div className="cs_faq_bubble_q">
                  <Icon icon="ph:question-bold" />
                </div>
                <Icon icon="ph:leaf-fill" className="cs_faq_leaf" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <div className="faq-container">
        {faqData.map((faq, index) => (
          <FAQItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === index}
            onClick={() =>
              setOpenIndex(openIndex === index ? null : index)
            }
          />
        ))}
      </div>
    </>
  );
}
